<template>

    <div class="divHeader" tabindex="0">CAAMS FAQs</div>
    
    <div class="divButtons">
        <span tabindex="0" @keydown.enter="handleShowQuestions" @click="handleShowQuestions" class="spanButtons buttonText">Show Questions</span>
        <span tabindex="0" @keydown.enter="handleShowAll" @click="handleShowAll" class="spanButtons buttonText">Show All</span>
        <span tabindex="0" @keydown.enter="handleHideAll" @click="handleHideAll" class="spanButtons buttonText">Hide All</span>
    </div>
    <!-- ------------------------------->
    <!-- --------- section 1 ----------->
    <!-- ------------------------------->
    
    <div class="divMain">
    
        <div tabindex="0" @keydown.enter="handleS1Click" @click="handleS1Click" class="divChildSection toggleCollapsePointer" :class="{divBottomBorder: showS1}">
            <span class="sectionFont">CAAMS Usage</span></div>
    
        <!-- ######### Q1 -->
        
        <div tabindex="0" @keydown.enter="s1Q1Click" @click="s1Q1Click" v-if="showS1" class="divChildQuestion">
            <strong><span class="toggleCollapsePointer questionFont">Is CAAMS required?</span></strong></div>
    
        <div v-if="showS1 && showS1Q1" class="divChildAnswer answerFont">
            <ul class="ulMarginSmall">
                <li tabindex="0">Within the CENTCOM AOR, CAAMS has been mandated for use for any contract that includes contractors armed
                    in any capacity, such as self-defence, security, etc.</li>
            </ul>
        </div>
    
        <!-- ######### Q2 -->
    
        <div tabindex="0" @keydown.enter="s1Q2Click" @click="s1Q2Click" v-if="showS1" class="divChildQuestion">
            <strong><span class="toggleCollapsePointer questionFont">
                    Can my contract bypass the CAAMS usage requirement? We have never needed to use CAAMS before.
            </span></strong>
        </div>
    
        <div v-if="showS1 && showS1Q2" class="divChildAnswer answerFont">
            <ul class="ulMarginSmall">
                <li>No, CAAMS is required for all new contracts with armed contractors within CENTCOM.</li>
            </ul>
        </div>
    
        <!-- ######### Q3 -->
    
        <div tabindex="0" @keydown.enter="s1Q3Click" @click="s1Q3Click" v-if="showS1" class="divChildQuestion" :class="{divLastQuestion: showS1Q3 == false}">
            <strong><span class="toggleCollapsePointer  questionFont">
                    My contract is not in the CENTCOM AOR. Can I still use CAAMS?
             </span></strong>
        </div>
    
        <div v-if="showS1 && showS1Q3" class="divChildAnswer answerFont">
            <ul>
                <li class="ulMarginSmall">CAAMS can be used in any other COCOM throughout the world. Please contract the CAAMS PMO for additional
                    information.</li>
            </ul>
        </div>
    
    </div>
    
    <!-- ------------------------------->
    <!-- --------- section 2 ----------->
    <!-- ------------------------------->
    
    <div class="divMain">
    
        <div tabindex="0" @keydown.enter="handleS2Click"  @click="handleS2Click" class="divChildSection toggleCollapsePointer" :class="{divBottomBorder: showS2}">
            <span class="sectionFont">CAAMS Training</span>
        </div>
        
        <!-- ######### Q1 -->
    
        <div tabindex="0" @keydown.enter="s2Q1Click" @click="s2Q1Click" v-if="showS2" class="divChildQuestion">
            <strong><span class="toggleCollapsePointer questionFont">
                How do I acces Helpdesk?
            </span></strong></div>
    
        <div v-if="showS2 && showS2Q1" class="divChildAnswer answerFont">
            <ul class="ulMarginSmall">
                <li >You can access the CAAMS Helpdesk by selecting the "Helpdesk & Feedback" button, located at the bottom
                    right of your screen.</li>
            </ul>
        </div>
        
        <!-- ######### Q2 -->
    
        <div tabindex="0" @keydown.enter="s2Q2Click" @click="s2Q2Click" v-if="showS2" class="divChildQuestion">
            <strong><span class="toggleCollapsePointer questionFont">
                Where can I find training documentation?
            </span></strong></div>
    
        <div v-if="showS2 && showS2Q2" class="divChildAnswer answerFont">
            <ul class="ulMarginSmall">
                <li>By selecting on of the CAAMS user guide links on the CAAMS home page.</li>
            </ul>
        </div>
        
        <!-- ######### Q3 -->
    
        <div tabindex="0" @keydown.enter="s2Q3Click" @click="s2Q3Click" v-if="showS2" class="divChildQuestion" :class="{divLastQuestion: showS1Q3 == false}">
            <strong><span class="toggleCollapsePointer questionFont">
                How can I recieve training on CAAMS?
            </span></strong></div>
    
        <div v-if="showS2 && showS2Q3" class="divChildAnswer answerFont">
            <ul>
                <li>By contacting Brian Perdue at <span class="emailText">robert.perdue.ctr@dla.mil</span></li>
            </ul>
        </div>
    
    </div>
    
    <!-- ------------------------------->
    <!-- --------- section 3 ----------->
    <!-- ------------------------------->
    
    <div class="divMain">
    
        <div tabindex="0" @keydown.enter="handleS3Click"  @click="handleS3Click" class="divChildSection toggleCollapsePointer" :class="{divBottomBorder: showS3}">
            <span class="sectionFont">Accessing CAAMS</span>
        </div>
        
        <!-- ######### Q1 -->
    
        <div tabindex="0" @keydown.enter="s3Q1Click" @click="s3Q1Click" v-if="showS3" class="divChildQuestion">
            <strong><span class="toggleCollapsePointer questionFont">
                What is the registration process?
            </span></strong></div>
    
        <div v-if="showS3 && showS3Q1" class="divChildAnswer answerFont">
            <ul class="ulMarginSmall">
                <li class="ulMarginBottomMedium">Gaining access to CAAMS is a multi-step process:</li>
                <ol class="ulMarginBottomSmall">
                    <li >Resgister with CAAMS by completing and submitting the online registration form. Be surte to select the appropriate role and provide all required
                        information.
                    </li>
                    <li>The CAAMS PMO will review your application and contact you should further information be required.</li>
                    <li>Upon review and approval, you CAAMS role will be associated with the requested contracts, and you will have immediate access to this data 
                        in CAAMS.
                    </li>
                    <li>Should you require access to additional contracts, please submit a Helpdesk + ticket. Include your contract information and the contract
                        number(s) to be associated with your account.
                    </li>
                </ol>
            </ul>
        </div>
        
        <!-- ######### Q2 -->
    
        <div tabindex="0" @keydown.enter="s3Q2Click" @click="s3Q2Click" v-if="showS3" class="divChildQuestion">
            <strong><span class="toggleCollapsePointer questionFont">
                What are the roles available in CAAMS?
            </span></strong>
        </div>
    
        <div v-if="showS3 && showS3Q2" class="divChildAnswer answerFont">
            <ul class="ulMarginSmall">
                <li tabindex="0" class="ulMarginBottomMedium">Vendor Role: A company supplying personnel for the completion of the arming process.
                In the vendor role, a user can upload documents and initiate an arming request.</li>
                <li class="ulMarginBottomMedium">KO/COR Role: A Contract Officer (KO) or a Contract Office Representative (COR) help
                facilitate the arming process by doing the following:
                <ul>
                    <li>Uploading/reviewing documents.</li>
                    <li>Submitting a Biometeric Verification Letter (if required).</li>
                    <li>Requesting an Officer memo.</li>
                    <li>Updating select data for each individual.</li>
                </ul>
            </li>
            <li tabindex="0">Read-only role: This is similar to the Vendor role, but with no ability
                to edit/change any information. This role will be associated with one or mor contracts.
            </li>
            </ul>
        </div>
        
        <!-- ######### Q3 -->
    
        <div tabindex="0" @keydown.enter="s3Q3Click" @click="s3Q3Click" v-if="showS3" class="divChildQuestion" :class="{divLastQuestion: showS3Q3 == false}">
            <strong><span class="toggleCollapsePointer questionFont">
                How long will it take for my account to be approved?
            </span></strong></div>
    
        <div v-if="showS3 && showS3Q3" class="divChildAnswer answerFont">
            <ul>
                <li>It normally takes 1-2 business days for an account to be approved.</li>
            </ul>
        </div>
    
    </div>
    
    <!-- ------------------------------->
    <!-- --------- section 4 ----------->
    <!-- ------------------------------->
    
    <div class="divMain">
    
    <div  tabindex="0" @keydown.enter="handleS4Click" @click="handleS4Click" class="divChildSection toggleCollapsePointer" :class="{divBottomBorder: showS4}">
        <span class="sectionFont">Contract Management</span>
    </div>
    
    <!-- ######### Q1 -->
    
    <div tabindex="0" @keydown.enter="s4Q1Click" @click="s4Q1Click" v-if="showS4" class="divChildQuestion">
        <strong><span class="toggleCollapsePointer questionFont">
            I am not seeing any contract information in the Process Master List.
        </span></strong></div>
    
    <div v-if="showS4 && showS4Q1" class="divChildAnswer answerFont">
        <ul class="ulMarginSmall">
            <li class="ulMarginBottomMedium">This may be due to various reasons:</li>
            <ol class="ulMarginBottomSmall">
                <li>If there have not been any individuals added to the contract, the list will be blank.</li>
                <li>If you have not been assigned to the contract, it will not appear on your process master list.
                    Enter a Helpdesk ticket to request access to the contract.
                </li>
                <li>If the information is all of a sudden not appearing, the contract has probably expired. In this case, submit
                    a Helpdesk ticket and indicate the missing contract number. If possible, provide any information regarding a 
                    contract extension.
                </li>
            </ol>
        </ul>
    </div>
        
        <!-- ######### Q2 -->
    
        <div tabindex="0" @keydown.enter="s4Q2Click" @click="s4Q2Click" v-if="showS4" class="divChildQuestion">
            <strong><span class="toggleCollapsePointer questionFont">
                How do I add to or change my contract numbers?
            </span></strong></div>
    
        <div v-if="showS4 && showS4Q2" class="divChildAnswer answerFont">
            <ul class="ulMarginSmall">
                <li>To update/add to your assigned contract numbers, submit a Helpdesk + ticket listing the contract
                    numbers that you need access to. Once the Helpdesk + ticket has been associated with your CAAMS account (with
                    submitted contracts), you automatically have access to your data. This data will appear on the Process Master list which
                    is found under the Contractors menu item.
                </li>
            </ul>
        </div>
        
        <!-- ######### Q3 -->
    
        <div tabindex="0" @keydown.enter="s4Q3Click" @click="s4Q3Click" v-if="showS4" class="divChildQuestion">
            <strong><span class="toggleCollapsePointer questionFont">
                What needs to be done if an existing contract is going to be extended?
            </span></strong></div>
    
        <div v-if="showS4 && showS4Q3" class="divChildAnswer answerFont">
            <ul class="ulMarginSmall">
                <li>Contact the CAAMS PMO with a Letter of Intent. Also, ensure that all LOA and deployment dates are current. A contract
                    extension will often require new LOAs for all individuals on the contract.
                </li>
            </ul>
        </div>
        
        <!-- ######### Q4 -->
    
        <div tabindex="0" @keydown.enter="s4Q4Click" @click="s4Q4Click" v-if="showS4" class="divChildQuestion">
            <strong><span class="toggleCollapsePointer questionFont">
                The arming process is complete, now what?
            </span></strong></div>
    
        <div v-if="showS4 && showS4Q4" class="divChildAnswer answerFont">
            <ul class="ulMarginSmall">
                <li>Once the contractor's package has gone through the arming authorization process, and the 
                    package has been marked as complete, it is the KO/CORs responsibility to confirm the arming
                    status of their armed contractors. Confirmation is done by checking/unchecking the "armed" checkbox
                    next to their name and clicking on the confirmed date button in order to update their status. For a
                    contract to be in compliance, the arming confirmation needs to be done monthly.
                </li>
            </ul>
        </div>
        
        <!-- ######### Q5 -->
    
        <div tabindex="0" @keydown.enter="s4Q5Click" @click="s4Q5Click" v-if="showS4" class="divChildQuestion" :class="{divLastQuestion: showS4Q5 == false}">
            <strong><span class="toggleCollapsePointer questionFont">
                Can I transfer a contractor to another contract of mine?
            </span></strong></div>
    
        <div v-if="showS4 && showS4Q5" class="divChildAnswer answerFont">
            <ul>
                <li>Yes, KO/CORs have the ability to transfer a contractor from under one of their contracts to
                    another contract under their control. From the Contract Detail page, click on the Transfer link
                    associated with the individual and select the new contract from the dropdown options. Notice, that doing
                    this will require the individual's information to be updated, and this may require a new LOA for the individual. <strong>Note:</strong> if
                    the Employer value needs to be updated, please submit a Helpdesk ticket.
                </li>
            </ul>
        </div>
    
    </div>
    
    <!-- ------------------------------->
    <!-- --------- section 5 ----------->
    <!-- ------------------------------->
    
    <div class="divMain" style="margin-bottom: 40px;">
    
    <div tabindex="0"  @keydown.enter="handleS5Click" @click="handleS5Click" class="divChildSection toggleCollapsePointer" :class="{divBottomBorder: showS5}">
        <span class="sectionFont">Document/Arming Process</span>
    </div>
    
    <!-- ######### Q1 -->
    
    <div tabindex="0" @keydown.enter="s5Q1Click" @click="s5Q1Click" v-if="showS5" class="divChildQuestion">
        <strong><span class="toggleCollapsePointer questionFont">
            Can I upload the complete Arming Packet?
        </span></strong></div>
    
    <div v-if="showS5 && showS5Q1" class="divChildAnswer answerFont">
        <ul class="ulMarginSmall">
            <li tabindex="0">No, each required document within the Arming Packet must be uploaded separately. The appropriate 
                document type should be selected each time a document is uploaded.</li>
        </ul>
    </div>
    
    <!-- ######### Q2 -->
    
    <div tabindex="0" @keydown.enter="s5Q2Click" @click="s5Q2Click" v-if="showS5" class="divChildQuestion">
        <strong><span class="toggleCollapsePointer questionFont">
            What are the minimum number of forms required for an armed contractor?
        </span></strong></div>
    
    <div v-if="showS5 && showS5Q2" class="divChildAnswer answerFont">
        <ul class="ulMarginSmall">
            <li tabindex="0" class="ulMarginBottomMedium">As of 12/01/2022, the minimum required documentation consists of the following:</li>
            <ul class="ulMarginBottomSmall">
                <li tabindex="0">SPOT Letter of Authorization (LOA)</li>
                <li tabindex="0">Background check or DD 2760
                </li>
                <li tabindex="0">Appropriate weapon qualification scorecard for each weapon to be used or host nation weapon permit.
                </li>
            </ul>
        </ul>
    </div>
    
    <!-- ######### Q3 -->
    
    <div tabindex="0" @keydown.enter="s5Q3Click" @click="s5Q3Click" v-if="showS5" class="divChildQuestion">
        <strong><span class="toggleCollapsePointer questionFont">
            What forms need to be redone for a renewal?
        </span></strong></div>
    
    <div v-if="showS5 && showS5Q3" class="divChildAnswer answerFont">
        <ul class="ulMarginSmall">
            <li tabindex="0">You will need a new LOA. The individual's record will also need to be updated with new the
                new LOA and deployment dates. If weapons are expired, or about to expire in less than 90 days,
                then the qualifications should be updated as well.
            </li>
        </ul>
    </div>
    
    <!-- ######### Q4 -->
    
    <div tabindex="0" @keydown.enter="s5Q4Click" @click="s5Q4Click" v-if="showS5" class="divChildQuestion">
        <strong><span class="toggleCollapsePointer questionFont">
            Are there any restrictions regarding what document types can/should be uploaded by Vendors?
        </span></strong></div>
    
    <div v-if="showS5 && showS5Q4" class="divChildAnswer answerFont">
        <ul class="ulMarginSmall">
            <li tabindex="0">Vendors should not upload the Biometric Verification (BV) letter. That document should be uploaded
                by the KO/COR at the respective stage in the arming process (BV stage). All other document types can be 
                uploaded by Vendors. <strong>*Note*</strong> that at the present time, the BV letter <strong>is not 
                    required/collected.</strong>
            </li>
        </ul>
    </div>
        
        <!-- ######### Q5 -->
    
        <div tabindex="0" @keydown.enter="s5Q5Click" @click="s5Q5Click" v-if="showS5" class="divChildQuestion" :class="{divLastQuestion: showS5Q5 == false}">
            <strong><span class="toggleCollapsePointer questionFont">
                What data is returned when I export to Excel?
            </span></strong></div>
    
        <div v-if="showS5 && showS5Q5" class="divChildAnswer answerFont">
            <ul>
                <li tabindex="0">The Export to Excel button wioll return the full results of any data loaded to the page. Filtering
                    the page, by using the on-page search functionality, does NOT decrease the data exported. This is
                    by design, to allow you to sort, filter, andanipulate the downloaded data as needed.
                </li>
            </ul>
        </div>
    
    </div>
    
</template>
    
    <script>
    export default {
      data() {
        return {
            // -------- section 1 ---------
            showS1: false,
            showS1Q1: false,
            showS1Q2: false,
            showS1Q3: false,
    
            // -------- section 2 ---------
            showS2: false,
            showS2Q1: false,
            showS2Q2: false,
            showS2Q3: false,
    
            // -------- section 3 ---------
            showS3: false,
            showS3Q1: false,
            showS3Q2: false,
            showS3Q3: false,
    
            // -------- section 4 ---------
            showS4: false,
            showS4Q1: false,
            showS4Q2: false,
            showS4Q3: false,
            showS4Q4: false,
            showS4Q5: false,
    
            // -------- section 5 ---------
            showS5: false,
            showS5Q1: false,
            showS5Q2: false,
            showS5Q3: false,
            showS5Q4: false,
            showS5Q5: false,
        };
      },
      created() {},
      methods: {
    
        // ---------------- all sections -----------
    
        handleShowQuestions() {
    
            // -------- section 1 ---------
            
            this.$data.showS1 = true;
            this.$data.showS1Q1 = false;
            this.$data.showS1Q2 = false;
            this.$data.showS1Q3 = false    
    
            // -------- section 2 ---------
    
            this.$data.showS2 = true;
            this.$data.showS2Q1 = false;
            this.$data.showS2Q2 = false;
            this.$data.showS2Q3 = false;
    
            // -------- section 3 ---------
            
            this.$data.showS3 = true;
            this.$data.showS3Q1 = false;
            this.$data.showS3Q2 = false;
            this.$data.showS3Q3 = false;
    
            // -------- section 4 ---------
            
            this.$data.showS4 = true;
            this.$data.showS4Q1 = false;
            this.$data.showS4Q2 = false;
            this.$data.showS4Q3 = false;
            this.$data.showS4Q4 = false;
            this.$data.showS4Q5 = false;
    
            // -------- section 5 ---------
            
            this.$data.showS5 = true;
            this.$data.showS5Q1 = false;
            this.$data.showS5Q2 = false;
            this.$data.showS5Q3 = false;
            this.$data.showS5Q4 = false;
            this.$data.showS5Q5 = false;
        },
    
        handleShowAll() {
    
            // -------- section 1 ---------
    
            this.$data.showS1 = true;
            this.$data.showS1Q1 = true;
            this.$data.showS1Q2 = true;
            this.$data.showS1Q3 = true;
    
            // -------- section 2 ---------
    
            this.$data.showS2 = true;
            this.$data.showS2Q1 = true;
            this.$data.showS2Q2 = true;
            this.$data.showS2Q3 = true;
    
            // -------- section 3 ---------
    
            this.$data.showS3 = true;
            this.$data.showS3Q1 = true;        
            this.$data.showS3Q2 = true;        
            this.$data.showS3Q3 = true;        
    
            // -------- section 4 ---------
    
            this.$data.showS4 = true;
            this.$data.showS4Q1 = true;        
            this.$data.showS4Q2 = true;        
            this.$data.showS4Q3 = true;        
            this.$data.showS4Q4 = true;        
            this.$data.showS4Q5 = true;        
    
            // -------- section 5 ---------
    
            this.$data.showS5 = true;
            this.$data.showS5Q1 = true;        
            this.$data.showS5Q2 = true;        
            this.$data.showS5Q3 = true;        
            this.$data.showS5Q4 = true;        
            this.$data.showS5Q5 = true;        
    
        },
    
        handleHideAll() {
    
            // -------- section 1 ---------
    
            this.$data.showS1 = false;
            this.$data.showS1Q1 = false;
            this.$data.showS1Q2 = false;
            this.$data.showS1Q3 = false;        
    
            // -------- section 2 ---------
    
            this.$data.showS2 = false;
            this.$data.showS2Q1 = false;
            this.$data.showS2Q2 = false;
            this.$data.showS2Q3 = false;
    
            // -------- section 3 ---------
    
            this.$data.showS3 = false;
            this.$data.showS3Q1 = false;        
            this.$data.showS3Q2 = false;        
            this.$data.showS3Q3 = false;        
    
            // -------- section 4 ---------
    
            this.$data.showS4 = false;
            this.$data.showS4Q1 = false;        
            this.$data.showS4Q2 = false;        
            this.$data.showS4Q3 = false;        
            this.$data.showS4Q4 = false;        
            this.$data.showS4Q5 = false;        
    
            // -------- section 5 ---------
    
            this.$data.showS5 = false;
            this.$data.showS5Q1 = false;        
            this.$data.showS5Q2 = false;        
            this.$data.showS5Q3 = false;        
            this.$data.showS5Q4 = false;        
            this.$data.showS5Q5 = false;        
        },
    
        // ------------ section 1 ------------
        handleS1Click() {
            this.$data.showS1 = !this.$data.showS1;
        },
        s1Q1Click() {
            this.$data.showS1Q1 = !this.$data.showS1Q1;
        },
        s1Q2Click() {
            this.$data.showS1Q2 = !this.$data.showS1Q2;
        },
        s1Q3Click() {
            this.$data.showS1Q3 = !this.$data.showS1Q3;
        },
    
        // ------------ section 2 ------------
        handleS2Click() {
            this.$data.showS2 = !this.$data.showS2;
        },
        s2Q1Click() {
            this.$data.showS2Q1 = !this.$data.showS2Q1;
        },
        s2Q2Click() {
            this.$data.showS2Q2 = !this.$data.showS2Q2;
        },
        s2Q3Click() {
            this.$data.showS2Q3 = !this.$data.showS2Q3;
        },
    
        // ------------ section 3 ------------
        handleS3Click() {
            this.$data.showS3 = !this.$data.showS3;
        },
        s3Q1Click() {
            this.$data.showS3Q1 = !this.$data.showS3Q1;
        },
        s3Q2Click() {
            this.$data.showS3Q2 = !this.$data.showS3Q2;
        },
        s3Q3Click() {
            this.$data.showS3Q3 = !this.$data.showS3Q3;
        },
    
        // ------------ section 4 ------------
        handleS4Click() {
            this.$data.showS4 = !this.$data.showS4;
        },
        s4Q1Click() {
            this.$data.showS4Q1 = !this.$data.showS4Q1;
        },
        s4Q2Click() {
            this.$data.showS4Q2 = !this.$data.showS4Q2;
        },
        s4Q3Click() {
            this.$data.showS4Q3 = !this.$data.showS4Q3;
        },
        s4Q4Click() {
            this.$data.showS4Q4 = !this.$data.showS4Q4;
        },
        s4Q5Click() {
            this.$data.showS4Q5 = !this.$data.showS4Q5;
        },
    
        // ------------ section 5 ------------
        handleS5Click() {
            this.$data.showS5 = !this.$data.showS5;
        },
        s5Q1Click() {
            this.$data.showS5Q1 = !this.$data.showS5Q1;
        },
        s5Q2Click() {
            this.$data.showS5Q2 = !this.$data.showS5Q2;
        },
        s5Q3Click() {
            this.$data.showS5Q3 = !this.$data.showS5Q3;
        },
        s5Q4Click() {
            this.$data.showS5Q4 = !this.$data.showS5Q4;
        },
        s5Q5Click() {
            this.$data.showS5Q5 = !this.$data.showS5Q5;
        },
    
      },
    };
    </script>
    
    <style>
    
    /* ------------- HEADER ------------- */
    
    .divHeader {
        font-size: x-large;
    }
    
    /* ------------ MAIN div --------------- */
    
    .divMain {
        border-radius: 5px;
        width: 85%;
        margin-left: 30px;
        border: 2px solid #a6a6a6;
        margin-bottom: 15px;
        text-align: left;
    }
    
    /* ------------ SECTION --------------- */
    
    .divBottomBorder {
        border-bottom: 1px solid #a6a6a6;
    }
    
    .divChildSection {
        border-radius: 3px;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
        text-align: left;
        background-color: #e6e6e6;
        padding-left: 10px;
        margin: 0px;
    }
    
    /* ------------ QUESTION --------------- */
    
    .divChildQuestion {
        text-align: left;
        padding-left: 10px;
        margin-top: 10px;
        margin-bottom: 2px;
    }
    
    .divLastQuestion {
        margin-bottom: 15px;
    }
    
    /* ------------ ANSWER --------------- */
    
    .divChildAnswer {
        text-align: left;
        padding-left: 10px;
        font-size: small;
        margin: 0px;
    }
    
    /* ------------ Hide Show --------------- */
    
    .toggleCollapsePointer {
        cursor: pointer
    }
    
    /* ------------ FONT --------------- */
    
    .sectionFont {
        font-size: medium;
    }
    
    .questionFont {
        font-size: small;
    }
    
    .answerFont {
        font-size: small;
    }
    
    /* ------------ LISTS --------------- */
    
    .ulMarginSmall {
        margin: 0px;
    }
    
    .ulMarginBottomSmall {
        margin-bottom: 0px;
    }
    
    .ulMarginBottomMedium {
        margin-bottom: 4px;
    }
    
    /* ------------- BUTTONS ------------- */
    
    .divButtons {
        border-radius: 5px;
        width: 85%;
        margin-left: 30px;
        border: 0px solid #a6a6a6;
        margin-bottom: 10px;
        text-align: left;
    }
    
    .buttonText {
        color: blue;
        font-size: small;
        text-decoration: underline;
        cursor: pointer;
    }
    
    .spanButtons {
        margin-right: 10px;
    }
    
    /* ------------- EMAIL ------------- */
    
    .emailText {
        color: blue;
        font-size: small;
        text-decoration: underline;
        cursor: pointer;
    }
    
    </style>